<mat-card style="height: 530px">
  <form #loginForm="ngForm">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <h3 style="padding-left:5px">{{editInvoiceData.clau}}. {{ 'invoiceEditDialog.titolRebuda' | translate }} {{editInvoiceData.numero_factura}}
      <button mat-icon-button style="clear:none;margin-left:10px" color="primary"
            (click)="openCurrencyDialog()"
            matTooltip="{{ 'propostaMi.economia.canviMonedaToolTip' | translate }}"
            attr.aria-label="{{ 'propostaMi.economia.canviMonedaAriaLabel' | translate }}">
            <mat-icon style="font-size:16px !important">currency_exchange</mat-icon>
        </button>
      </h3>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-right:0" (click)="desar()" matTooltip="{{ 'common.desar' | translate }}" attr.aria-label="{{ 'common.desar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>  
    </mat-toolbar>
    <mat-card-content style="float:left;clear:both;padding: 24px 5px;">
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.numeroFactura' | translate }}" name="numero" required
        [(ngModel)]="editInvoiceData.numero_factura" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:130px">
        <mat-select style="width:130px" [(ngModel)]="data.concepte" placeholder="{{ 'invoiceEditDialog.concepte' | translate }}" name="concepte">
          <mat-option *ngFor="let concepte of possibleConceptes" [value]="concepte.value" [selected]="concepte.value === editInvoiceData.concepte">{{concepte.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataFacturacioPrevista' | translate }}" name="data_factura_prevista" type="date"
        [(ngModel)]="editInvoiceData.data_factura_prevista" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataPagamentPrevista' | translate }}" name="data_pagament_prevista" type="date"
        [(ngModel)]="editInvoiceData.data_pagament_prevista" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataFacturacio' | translate }}" name="data_factura" type="date"
        [(ngModel)]="editInvoiceData.data_factura" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataPagament' | translate }}" name="data_pagament" type="date"
        [(ngModel)]="editInvoiceData.data_pagament" ngDefaultControl
       />
      </mat-form-field>
      <div style="float:left;clear:left;width:100%"> 
        <mat-form-field style="width:130px">
         <input matInput  style="width:130px"
          placeholder="{{ 'invoiceEditDialog.facturacioPercent' | translate }}" name="facturacio_prevista_percent" type="number" step="0.01" required
          [(ngModel)]="editInvoiceData.facturacio_prevista_percent" ngDefaultControl
         />
        </mat-form-field> 
        <mat-form-field style="width:130px">
         <input matInput style="width:130px"
          placeholder="{{ 'invoiceEditDialog.importBase' | translate }}" name="facturacio_loc" type="number" step="0.01"
          [(ngModel)]="editInvoiceData.facturacio_loc" ngDefaultControl
         />
        </mat-form-field> 
        <mat-form-field style="width:130px">
          <mat-select style="width:90px;padding-right:100px" [(ngModel)]="data.moneda_facturacio" placeholder="{{ 'propostaMi.economia.moneda' | translate }}" name=" moneda_facturacio">
            <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.codi" [selected]="moneda.text === editInvoiceData.moneda_facturacio">{{moneda.text}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field style="width:130px">  
          <input matInput type="number" step="0.01" style="width:130px"
          placeholder="{{ 'propostaMi.economia.canvi' | translate }}" name="canvi_moneda"
          [(ngModel)]="editInvoiceData.canvi_moneda" formatNumberPipe ngDefaultControl
          />
        </mat-form-field>
        <mat-form-field style="width:130px">
         <input matInput style="width:130px"
          placeholder="{{ 'invoiceEditDialog.facturacioEur' | translate }}" name="facturacio_prevista_eur" type="number" step="0.01" disabled style="width:130px;color:#777777" formatNumberPipe 
          value="{{editInvoiceData.facturacio_loc*editInvoiceData.canvi_moneda}}" ngDefaultControl
         />
        </mat-form-field>
      </div>
      <div style="float:left;clear:left;width:100%"> 
        <mat-form-field style="width:130px">
         <input matInput style="width:130px"
          placeholder="{{ 'invoiceEditDialog.impostosEurSign' | translate }}" name="impostos" type="number" step="0.01" required
          [(ngModel)]="editInvoiceData.impostos" ngDefaultControl
         />
        </mat-form-field> 
        <mat-form-field style="width: 55%">
         <input matInput 
          placeholder="{{ 'invoiceEditDialog.nomEmpresa' | translate }}" name="fita"
          [(ngModel)]="editInvoiceData.fita" ngDefaultControl
         />
        </mat-form-field>
      </div>
      <mat-checkbox style="margin-left: 1em;" name="activa"
        [(ngModel)]="editInvoiceData.activa">
        {{ 'facturacio.taula.colActiva' | translate }}
      </mat-checkbox>
      <mat-form-field style="width:100%">
       <textarea matInput placeholder="{{ 'invoiceEditDialog.objecteLliurament' | translate }}" name="objecte_lliurament" rows="4" [(ngModel)]="editInvoiceData.objecte_lliurament" style="width: 100%">
        </textarea>
      </mat-form-field> 
      <mat-form-field style="width:100%">
        <textarea matInput placeholder="{{ 'facturacio.taula.colObservacions' | translate }}" name="observacions" rows="3" [(ngModel)]="editInvoiceData.observacions" style="width: 100%">
        </textarea>
      </mat-form-field> 
    </mat-card-content>
  </form>
</mat-card>
